var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";

import Author from "author/components/Author/Author";
import Authorize from "components/Library/Authorize/Authorize";
import Events from "events/components/Events";
import SearchResults from "search/components/SearchResults";
import Subscription from "subscriptions/components/Subscription";
import Subscriptions from "subscriptions/components/Subscriptions";
import UserSettings from "users/components/UserSettings/UserSettings";
import SavedStories from "users/components/SavedStories/SavedStories";
import Legal from "legal/components/Legal/Legal";
import About from "about/components/About/About";
import StoryPermalink from "dashboard/containers/StoryPermalink";
import SectionStream from "dashboard/containers/SectionStream";
import TagStream from "dashboard/containers/TagStream";
import NotFound from "dashboard/components/NotFound";

import { getStoriesStream } from "actions/storiesStream";
import { getNewsletter, populateSubscription } from "subscriptions/actions/subscriptions";
import { getRedirectPath } from "utils/server";
import { setSectionWithTag, getSection, setLastSeen } from "actions/navigation";
import { getAuthor } from "author/actions/author";

import { URL_ID_REGEXP } from "config/constants";

var oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
var storyPermalinkRoute = "/:slug([A-Za-z0-9-]+?-)?:id" + URL_ID_REGEXP + ".html";
var newsletterPermalinkRoute = "/newsletters/:subscription([A-Za-z0-9-]+)?-:newsletter" + URL_ID_REGEXP + ".html";

export var routes = [{
  path: "/",
  exact: true,
  render: function render(props) {
    return React.createElement(SectionStream, _extends({}, props, { slug: "top" }));
  },
  fetchData: function fetchData(req, match, dispatch) {
    var featuredReturnId = req.cookies.lastSeen || "";

    return Promise.all([dispatch(getSection("top")), dispatch(setLastSeen(featuredReturnId)), dispatch(getStoriesStream({ stream: "top", featured_return_id: featuredReturnId }))]);
  }
}, {
  path: "/authors/:username",
  exact: true,
  component: Author,
  fetchData: function fetchData(req, match, dispatch) {
    return dispatch(getAuthor(match.params.username));
  }
}, {
  path: "/authorize",
  exact: true,
  component: Authorize
}, {
  path: "/results",
  exact: true,
  component: SearchResults
}, {
  path: "/legal",
  exact: true,
  component: Legal
}, {
  path: "/about",
  exact: true,
  component: About
}, {
  path: "/events",
  exact: true,
  component: Events
}, {
  path: "/newsletters",
  exact: true,
  component: Subscriptions
}, {
  path: newsletterPermalinkRoute,
  exact: true,
  component: Subscription,
  fetchData: function fetchData(req, match, dispatch, context) {
    return Promise.all([getRedirectPath(req, match.params.newsletter, context), dispatch(getNewsletter(match.params.newsletter)), dispatch(populateSubscription(match.params.subscription))]);
  }
}, {
  path: "/newsletters/:subscription",
  exact: true,
  component: Subscription,
  fetchData: function fetchData(req, match, dispatch) {
    return dispatch(populateSubscription(match.params.subscription));
  }
}, {
  path: "/users/settings",
  exact: true,
  component: UserSettings
}, {
  path: "/users/saved-stories",
  exact: true,
  component: SavedStories
}, {
  path: "/tag/:tag",
  exact: true,
  component: TagStream,
  fetchData: function fetchData(req, match, dispatch) {
    return dispatch(setSectionWithTag(match.params.tag));
  }
}, {
  path: storyPermalinkRoute,
  component: StoryPermalink,
  fetchData: function fetchData(req, match, dispatch, context) {
    if (req.query.preview || req.query.revision) return Promise.resolve();
    return Promise.all([getRedirectPath(req, match.params.id, context), dispatch(getStoriesStream({ story: match.params.id }))]);
  }
}, {
  path: oldPermalinkRoute,
  render: function render() {
    null;
  },
  fetchData: function fetchData(req, match, dispatch, context) {
    return getRedirectPath(req, match.params.id, context);
  }
}, {
  path: "/community/:user",
  fetchData: function fetchData(req, match, dispatch, context) {
    context.status = 301;
    context.path = "/authors/" + match.params.user;
    return Promise.resolve();
  }
}, {
  path: "/:section([a-zA-Z-]+)",
  render: function render(props) {
    return React.createElement(SectionStream, _extends({}, props, { slug: props.match.params.section }));
  },
  fetchData: function fetchData(req, match, dispatch) {
    var featuredReturnId = req.cookies.lastSeen || "";

    return Promise.all([dispatch(getSection(match.params.section)), dispatch(setLastSeen(featuredReturnId)), dispatch(getStoriesStream({ stream: match.params.section, featured_return_id: featuredReturnId }))]);
  },
  exact: true
},
// 404 fallback route
{
  path: "/*",
  render: function render(_ref) {
    var staticContext = _ref.staticContext;

    if (staticContext) staticContext.status = 404;
    return React.createElement(NotFound, null);
  }
}];


// WEBPACK FOOTER //
// ./src/routes.js